<template>
  <div class="live-room">
    <ul class="live-link" v-if="list.length !== 0">
      <!-- 返回的 active 是一个字符串，就离谱-->
      <li v-for="(item, key) in list" :key="key" :class="{ active: item.active !== 'false' }"
        @click="toggleActive(key)">
        <UiLabel>{{ item.key }}</UiLabel>
      </li>
    </ul>

    <div class="cheer-for">
      <div class="cheer-btn">
        <button @click="handleClickCheer" class="cheer" :class="{ anime: giftingEnabled }"></button>
        <UiTipDot v-show="clickedToday" placement="button"></UiTipDot>
      </div>
      <!-- 直播竞猜按钮 -->
      <div class="quiz-entrance" :style="{ display: 'block' }" @click="handleClickQuiz">
        <UiTipDot v-show="showLingqu.quizHots.liveReal" placement="button"></UiTipDot>
      </div>

      <div class="amount-entrance" @click="handleClickGetAmount" style="display: block">
        <UiTipDot v-show="showLingqu.taskHots.liveDaily" placement="button"></UiTipDot>
      </div>
    </div>
    <PresentPanel @openPresent="openPresent" />
    <QuizPanel />
    <DailyTasks />
    <GivePresent />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useAppStore, useStageStore } from '@/store'
import * as api from '@/service/index'
import GivePresent from '@/views/ranking/modal/present.vue'
import PresentPanel from './present-panel.vue'
import QuizPanel from './quiz-panel.vue'
import DailyTasks from './daily-tasks.vue'
import UiTipDot from '@/components/ui-tip-dot.vue'
import UiLabel from '@/components/ui-label.vue'

const props = defineProps({
  list: {
    type: Array,
    default: () => []
  },
  data: {
    type: Array,
    default: () => []
  },
})

const emit = defineEmits(['updatelivelink', 'bettingLimit'])

const route = useRoute()

const appStore = useAppStore()
const stageStore = useStageStore()

const clickedToday = ref(true) //控制红点展示
const serverDate = ref('') // 用于存储服务端返回的时间

const amount = computed(() => appStore.amount)
const token = computed(() => appStore.token)
const showLingqu = computed(() => appStore.showLingqu)
const giftingEnabled = computed(() => stageStore.giftingEnabled)

function toggleActive(key) {
  if (props.list[key].active === 'true') {
    return
  }
  props.list.forEach((item) => {
    item.active = 'false'
  })
  const item = props.list[key]
  item.active = 'true'
  emit('updatelivelink', item.value)
}
function handleClickCheer() {
  if (!token.value) return
  // 打开时记录一次点击日期, 联动按钮红点显隐
  if (giftingEnabled.value) fetchServerTime()
  appStore.openModal({ id: 'present-panel' })
}
async function fetchServerTime() {
  try {
    const response = await api.reqcurrentTime(); // 假设这个方法能请求到服务器时间
    if (response.status === 200) {
      serverDate.value = new Date(response.data); // 将服务端时间转换为 Date 对象
      const date = new Date(response.data);
      serverDate.value = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
      checkIfClickedToday()
    }
  } catch (error) {
    console.error('获取服务器时间失败', error);
  }
}


function checkIfClickedToday() {
  const savedDate = localStorage.getItem('buttonClickDate'); // 从 localStorage 中获取保存的日期
  if (savedDate && savedDate === serverDate.value) {
    // console.log('今天点击过了');
    // savedDate === this.serverDate ? this.clickedToday = true : this.clickedToday = false
    // 说明今天点击了
    localStorage.setItem('buttonClickDate', serverDate.value);
    clickedToday.value = false
  } else {
    clickedToday.value = true
    localStorage.setItem('buttonClickDate', serverDate.value);

  }

}
async function openPresent(item) {
  if (!token.value) return
  // 双阶段: 先空 params 打开占位, 拉完礼物再填 params 刷新
  appStore.openModal({ id: 'present', params: { team: '', presentList: '' } })
  appStore.reqUserInfo(true)
  const res = await fetchGetGiftList({ token: token.value, force: false })
  if (res.length) {
    appStore.openModal({ id: 'present', params: { team: item, presentList: res } })
  }
}


// 获取礼物内容
async function fetchGetGiftList(data) {
  try {
    const req = await api.reqGiftList(data)
    if (req.status === 200) {
      // console.log('123',req.data)
      return req.data
    }
  } catch (err) {
    console.log(err)
  }
}
function handleClickGetAmount() {
  appStore.openModal({ id: 'daily-tasks' })
}
function handleClickQuiz() {
  // 竞猜币上限拦截
  if (amount.value.quizRemainNum >= 99999) {
    emit('bettingLimit')
    return
  }
  appStore.openModal({ id: 'live-quiz' })
}

// created
fetchServerTime()
// 强刷一次
// TODO 二阶段开放
if (token.value) {
  fetchGetGiftList({ token: token.value, force: true })
}

onMounted(() => {
  // 直链带 is_send query 时自动打开 cheer 抽屉
  if (route.query.is_send) handleClickCheer()
})
</script>

<style lang="scss" scoped>
@import "index";
</style>
